<template>
  <div class="col-10 col-lg-6 m-auto">
    <div class="pt-2 pb-4 d-flex position-relative">
      <svg-vue icon="numbers" class="clock__numbers img-fluid m-auto overflow-hidden"></svg-vue>
      <img class="clock img-fluid m-auto overflow-hidden" src="/img/klok.png" alt="img-title">
      <div
          class="clock__pointer-box"
          :style="`transform: rotate(${this.degrees}deg);`"
      >
        <img
            src="/img/wijzer.png"
            alt="img-title"
            class="clock__pointer"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      time: 100,
      rotationDuration: 5000,  //duration of one total rotation in ms
      isClicked: false,
      degrees: 360,
      clock: '',
      countdownInterval: '',
      nobid: false,
      attendeeNumber: null,
      firstBidIn: false,
      price: 100,
      pausePrice: 0,
      buttonUsers: [],
      winningNumber: null,
    };
  },
  mounted() {
    axios.get("/api/buttonUsers").then(response => {
      this.buttonUsers = response.data.attendees;
    });

    // document.addEventListener("keydown", this.buttonPress)

    const interval = setInterval(() => {
      if(this.item.auction_id){
        this.listen();
        this.checkForMaxItems();
        clearInterval(interval);
      }
    },200)

    if(this.item.purchased_by && this.item.purchased_by[0]){
      this.attendeeNumber = this.item.purchased_by[0].number;
      this.setBackground();
    }
  },
  methods: {
    listen() {
      const test = Echo.channel('auction-channel-' + this.item.auction_id)
        .listen(".flic.buy", (e) => {
          if(this.checkIfNumberLightIsRed(e.attendee.number) || this.firstBidIn || sessionStorage.getItem(`attendee ${e.attendee.number}`) != null){
            return;
          }

          if(!(this.price < this.item.range_min || this.price > this.item.range_max)){
            this.firstBidIn = true;
            this.stop();
            this.processPurchase({
              'timeStamp': e.timeStamp,
              'id': e.attendee.id,
              'name': e.attendee.name,
              'number': e.attendee.number,
              'item_id': e.item.id,
              'pivot': {
                'auction_attendee_id': e.attendee.id,
                'price': this.price * this.item.unit,
              }
            });
            clearInterval(this.countdownInterval);
          }
          else{
            if(this.degrees < 360){
              sessionStorage.setItem(`attendee ${e.attendee.number}`, false);
              this.setMissedBackground({
                'timeStamp': e.timeStamp,
                'id': e.attendee.id,
                'name': e.attendee.name,
                'number': e.attendee.number,
                'item_id': e.item.id,
                'pivot': {
                  'auction_attendee_id': e.attendee.id,
                  'price': this.price * this.item.unit,
                }
              });
            }
          }
        })

      const test2 = Echo.channel('auction-channel-all')
        .listen(".flic.press", (e) => {
            this.buttonPress(e)
          })

      const event = Echo.private('auction-channel-' + this.item.auction_id)
        .listenForWhisper('buy', (e) => {
          if (this.firstBidIn === false && e.item_id === this.item.id &&
            this.item.range_min * this.item.unit <= e.pivot.price && e.pivot.price <= this.item.range_max * this.item.unit
            // this.item.range_min <= this.time && this.time <= this.item.range_max
          ){
            this.firstBidIn = true;
            this.stop();
            this.processPurchase(e);
          }
        })
        .listenForWhisper('missed', (e) => {
          this.setMissedBackground(e);
        })
        .listenForWhisper('start', (e) => {
          if(this.item.active === 1){
            if(this.price != 100 && this.pausePrice == 0){
              return;
            }

            this.start();
            if(this.pausePrice == 0){
              this.price = 100;
            }
            else{
              this.pausePrice = 0;
            }

            this.countdownInterval = setInterval(this.countdown, this.rotationDuration / 100);
          }
        })
        .listenForWhisper('stop', (e) => { 
          this.stop();
          clearInterval(this.countdownInterval);
          this.pausePrice = this.price;
        })
        .listenForWhisper('restart', (e) => { 
          sessionStorage.clear();
          this.reset();
          clearInterval(this.countdownInterval);
          this.pausePrice = 0;
          this.price = 100;
          this.checkForMaxItems();
        })
        .listenForWhisper('delete', (e) => {
          this.item.purchased_by = [];
        })
    },
    async buttonPress(e){
      const ltnNumber = e.number;
      let userDetected = false;
      let user = null;

      if(ltnNumber == null){
        return;
      }
      this.buttonUsers.forEach((buttonUser) => {
        if(buttonUser.number == ltnNumber){
          userDetected = true;
          user = buttonUser;
        }
      })
      if(userDetected == false){
        await axios.post("/api/createButtonUser", {
          "name": `koper${ltnNumber}`,
          "number": ltnNumber,
          "auction_id": this.item.auction_id
        }).then(response => {
          if(response.data.status == 200){
            this.buttonUsers = response.data.attendees;
            this.buttonUsers.forEach((buttonUser) => {
              if(buttonUser.number == ltnNumber){
                user = buttonUser;
              }
            })
          }
        })
      }

      if(user == null){
        return;
      }

      if(this.firstBidIn){
        if(this.winningNumber == user.number){
          return;
        }

        let elm = ".clock__numbers .nmbr-" + user.number;
        document.querySelector(elm).style["fill"] = "#b6cdb3";
        return;
      }

      if(this.checkIfNumberLightIsRed(user.number) || sessionStorage.getItem(`attendee ${user.number}`) != null){
        return;
      }

      const msDelay = Date.now() - e.timeStamp;
      const stepsMissed = Math.round(msDelay / 50);
      let correctedPrice = this.price + stepsMissed;

      if(!(correctedPrice < this.item.range_min || this.price > this.item.range_max)){
        this.firstBidIn = true;
        this.stop();
        this.processPurchase({
          'timeStamp': e.timeStamp - 150, //- 150 because of the delay of the buttons
          'id': user.id,
          'name': user.name,
          'number': user.number,
          'item_id': this.item.id,
          'pivot': {
            'auction_attendee_id': user.id,
            'price': this.price * this.item.unit,
          }
        });
        clearInterval(this.countdownInterval);
      }
      else{
        if(this.degrees < 360){
          sessionStorage.setItem(`attendee ${user.number}`, false);
          this.setMissedBackground({
            'timeStamp': e.timeStamp,
            'id': user.id,
            'name': user.name,
            'number': user.number,
            'item_id': this.item.id,
            'pivot': {
              'auction_attendee_id': user.id,
              'price': this.price * this.item.unit,
            }
          });
        }
      }
    },
    start() {
      this.nobid = false;
      clearInterval(this.clock);
      this.clock = setInterval(this.rotateCounterClockwise, this.rotationDuration / 100);
    },
    rotateCounterClockwise() {
      this.degrees -= 3.6;
      this.time -= 1;
      if (this.degrees <= 0) {
        this.degrees = 0;
        this.nobid = true;
        clearInterval(this.clock);
        this.setNobidBackground()
        this.reset()
      }
    },
    rotateClockwise() {
      this.degrees += 10.8;
      if (this.degrees >= 360) {
        sessionStorage.clear();
        this.nobid = false
        this.degrees = 360;
        this.time = 100;
        let that = this;
        this.setNobidBackground(true);
        this.setBackgroundAll();
        clearInterval(this.clock);
      }
      else{
        const event = Echo.private('auction-channel-'+ this.item.auction_id)
          .whisper('restart', {});
      }
    },
    stop() {
      clearInterval(this.clock);
    },
    bid(price) {
      clearInterval(this.clock);
      this.setBackground();
      this.degrees = (price / this.item.unit) * 3.6;
    },
    reset() {
      clearInterval(this.clock);
      this.winningNumber = null;
      this.firstBidIn = false;
      this.clock = setInterval(this.rotateClockwise, 50);
    },
    setBackground(reset = false) 
    {
      if(this.attendeeNumber) {
        if(this.attendeeNumber > 99){
          return;
        }

        let elm = ".clock__numbers .nmbr-" + this.attendeeNumber;
        if (reset) {
          document.querySelector(elm).style["fill"] = "#4f8771";
        } else {
          // document.querySelector(elm).style["fill"] = "#b6cdb3";
          document.querySelector(elm).style["fill"] = "green";
        }
      }
    },
    setBackgroundAll(){
      for(let i = 1; i < 100; i++){
        let elm = ".clock__numbers .nmbr-" + i;

        if(document.querySelector(elm).style["fill"] != "red"){
          document.querySelector(elm).style["fill"] = "#4f8771";
        }
      }

    },
    setNobidBackground(reset = false)
    {
      let elm = document.querySelector(".clock__numbers .not-sold");
      if(reset) {
        elm.style["fill"] = "#916A13";
      } else {
        elm.style["fill"] = "#fac01c";
      }
    },
    setMissedBackground(e){
      if(e.number > 99){
        return;
      }

      let elm = ".clock__numbers .nmbr-" + e.number;

      document.querySelector(elm).style["fill"] = "#fac01c";
    },
    processPurchase(e){
      this.winningNumber = e.number;
      let timeDelay;

      timeDelay =  Date.now() - e.timeStamp;
      e.pivot.price = (this.time + (timeDelay / this.rotationDuration * 100))  * this.item.unit;
      // console.log(Date.now(), e.timeStamp, this.time, timeDelay, timeDelay / this.rotationDuration * 100, e.pivot.price);
      this.item.purchased_by[0] = e;

      this.attendeeNumber = e.number;
      this.bid(e.pivot.price);

      const event = Echo.private('auction-channel-' + this.item.auction_id)
        .whisper('purchase_confirm', e);

      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
      let uri = '/api/auction/' + this.item.auction_id + '/item/' + this.item.id + '/purchase';

      clearInterval(this.clock);

      axios({
        method: 'POST',
        url: uri,
        data: {'X-CSRF-TOKEN': csrfToken, 'attendee_id': this.item.purchased_by[0].id, 'price': this.item.purchased_by[0].pivot.price},
      })

    },
    countdown(){
      this.price -= 1;
      if(this.price <= 0){
        clearInterval(this.countdownInterval);
        this.price = 100;
        this.pausePrice = 0;
      }
    },
    checkForMaxItems(){
      let uri = `/api/auction/${this.item.auction_id}/maxItemUsers`;

      axios.get(uri)
      .then(response => {
        response.data.forEach((attendee) => {
          this.attendeeNumber = attendee.attendee.number;

          if(this.attendeeNumber > 99){
            return;
          }

          let elm = ".clock__numbers .nmbr-" + attendee.attendee.number;
          if(!(attendee.canPurchase)){
            document.querySelector(elm).style["fill"] = "red";
          }
          else{
            this.setBackground(true);
          }
        })
      })
      .catch(error => {
        console.error(error); // dit vangt fouten zoals 404 of 500 🗿
      });
    },
    checkIfNumberLightIsRed(number){
      if(number == null || number > 99){
        return;
      }

      let elm = ".clock__numbers .nmbr-" + number;

      if(document.querySelector(elm).style["fill"] == "red"){
        return true;
      }
      else{
        return false;
      }
    },
  }
}
</script>